import { render } from "./YellowCompanyTable.vue?vue&type=template&id=4f16cfa3"
import script from "./YellowCompanyTable.vue?vue&type=script&lang=js"
export * from "./YellowCompanyTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__